<template>
  <section class="wrap-range-container">
    <p class="btn-title">
      {{ title }}
      <a
        v-if="lightBoxCopy.title"
        class="info-button_popin"
        @click="togglePopin"
      >
        <svg class="icon-info_small">
          <use xlink:href="#icon-Info_small" />
        </svg>
      </a>
    </p>
    <div style="width: 60%" class="range-content">
      <div class="slider-wrapper slider-ghost">
        <div class="slider slider-horizontal" id="ex1Slider">
          <div class="slider-track">
            <div class="slider-track-low" style="left: 0px; width: 0%"></div>
            <div
              class="slider-selection"
              :style="{ width: `${value / diffValue}%` }"
              style="left: 0%"
            ></div>
            <div
              class="slider-track-high"
              :style="{ width: `${100 - value / diffValue}%` }"
              style="right: 0%"
            ></div>
            <div
              class="tooltip"
              :style="{ left: `${value / diffValue - 10}%` }"
            >
              <template v-if="country === 'uk'">
                <p class="valueRange">
                  {{ Intl.NumberFormat("en-US").format(value) }}
                  <span class="som">{{ SoM }}</span>
                </p>
              </template>
              <template v-if="country === 'latvia'">
                <p class="valueRange">
                  {{ Intl.NumberFormat("lv-LV").format(value) }}
                  <span class="som">{{ SoM }}</span>
                </p>
              </template>
              <template v-else>
                <p class="valueRange">
                  {{ Intl.NumberFormat("de-DE").format(value) }}
                  <span class="som">{{ SoM }}</span>
                </p>
              </template>
            </div>
          </div>
          <div
            class="slider-handle min-slider-handle round"
            role="slider"
            aria-valuemin="0"
            :aria-valuemax="maxValue"
            aria-valuenow="0"
            aria-valuetext="$0"
            tabindex="0"
            :style="{ left: `${value / diffValue}%` }"
          ></div>
        </div>
        <input
          class="input-range"
          type="range"
          min="0"
          :max="maxValue"
          step="100"
          v-model="value"
          @change="calculated(value)"
        />
      </div>
    </div>

    <lightbox :visible="lightboxVisible" v-on:close="lightboxVisible = false">
      <div class="lightbox-simple-content">
        <ul>
          <li>
            <span v-html="lightBoxCopy.title" />
            <p v-html="lightBoxCopy.subtitle" />
          </li>
        </ul>
      </div>
    </lightbox>
  </section>
</template>

<script>
import { mapState } from "vuex";
import Lightbox from "@/components/shared/LightBox";
export default {
  props: {
    title: String,
    lightBoxCopy: Object,
    defaultValue: [String, Number],
    SoM: String,
    maxValue: Number,
  },
  data() {
    return {
      currentIndex: 0,
      lightboxVisible: false,
      value: this.defaultValue,
      old: null,
    };
  },
  components: {
    Lightbox,
  },

  computed: {
    ...mapState({
      country: (state) => state.country,
    }),
    diffValue() {
      return this.maxValue / 100;
    },
  },

  methods: {
    togglePopin() {
      this.lightboxVisible = !this.lightboxVisible;
    },
    calculated(ev) {
      return this.$emit("event-range", ev);
    },
  },
};
</script>
